import React from 'react';
import { DialogTrigger, Flex, View } from '@adobe/react-spectrum';
import { getProjectState } from 'app/stores/project';
import { ProjectActions } from 'app/stores/project/actions';
import { useAppDispatch } from 'app/stores/store';
import { ColorButton } from 'app/views/components/core/ColorButton';
import { ColorsGrid } from 'app/views/components/editor/pickers/ColorsGrid';
import { Text as CustomText } from 'app/views/components/typography/Text';
import { useConnect } from 'app/views/hooks/useConnect';
export const ColorPicker = () => {
    const dispatch = useAppDispatch();
    const { color: currentColor, colors } = useConnect(state => {
        const projectState = getProjectState(state);
        return {
            color: projectState.color,
            colors: state.editor.colors,
        };
    });
    const setColor = (color, commit = true) => {
        dispatch(ProjectActions.setProperty({
            property: 'color',
            value: color,
            undoable: commit,
        }));
    };
    const mainViewLayout = configGet('desktopMainViewLayout', 'row');
    const placement = mainViewLayout === 'row' ? 'right' : 'bottom';
    return (React.createElement(Flex, { direction: "column", alignItems: "center", justifyContent: "center" },
        React.createElement(DialogTrigger, { type: "popover", mobileType: "tray", placement: placement, hideArrow: true },
            React.createElement(ColorButton, { width: "size-250", height: "size-350", color: currentColor }),
            close => (React.createElement(View, { padding: "size-200" },
                React.createElement(ColorsGrid, { showPicker: true, color: currentColor, colors: colors, onSelect: color => {
                        setColor(color);
                        close();
                    }, onChange: setColor })))),
        React.createElement(CustomText, { size: "XS", tag: "p" }, "Color")));
};
